import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'partnerhub-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CalendarComponent),
      multi: true,
    },
  ],
})
export class CalendarComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private readonly complete$ = new Subject();

  @Input() public dateFormat: string;

  public formControl = new FormControl();

  @Input() public monthNavigator = false;

  @Input() public placeholder = '';

  @Input() public showButtonBar = false;

  @Input() public yearNavigator = false;

  @Input() public dataType = 'date';

  @Input() public yearRange: string;

  constructor() {}

  public ngOnDestroy(): void {
    this.complete$.next(true);

    this.complete$.complete();
  }

  public ngOnInit(): void {
    this.formControl.valueChanges
      .pipe()
      .subscribe(() => {
        this.onChange(this.formControl.value)
        this.onDateSelect(this.formControl.value)
      });
  }

  public onChange = (_: string) => {};

  public onDateSelect = (_: string) => {};

  public onTouch = () => {};

  public registerOnChange(fn: any): void {
    this.onChange = fn;
    this.onDateSelect = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }

  public writeValue(value: string): void {
    this.formControl.setValue(value);

    this.onChange(this.formControl.value);
    this.onDateSelect(this.formControl.value);
  }
}
